import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'

export function isSelfServiceRebookAllowed(offer?: App.Offer, order?: App.Order): boolean {
  if (!offer) return false
  if (order?.orderGift) return false
  return !!offer.packageUpgradesAllowed && scheduleIsCurrent(offer.onlinePurchaseSchedule)
}
